import LastUpdateDate from './LastUpdateDate';

export default LastUpdateDate;
